export const getVehicleHeroImage = (stockNumber: string | number) => {
    return `<img class="vehicle_hero-img" src="https://img2.carmax.com/assets/${stockNumber}/hero.jpg" alt="Vehicle with stock number ${stockNumber}" />`;
}